<template>
<!-- HEAD -->
<div class="container-xxl">
    <!-- titol -->
    <div class="row justify-content-between">
        <div class="col-12 col-lg-4 py-4 text-start">
            <p class="txtBlau2 my-0">{{ $t('site.avanzando-hacia-el-futuro')}}</p>
            <h2 class="text-uppercase">{{ $t('crecimiento.crecimiento')}}<br></h2>
        </div>
        <div class="col-6 text-start py-5 d-none d-lg-block">
            <h5>{{ $t('crecimiento.la-continua-evolución')}}</h5>
        </div>
    </div>
</div>
<div class="container-fluid">
    <!-- foto -->
    <div class="row">
        <div class="col-12 p-0 m-0 overflow-hidden">
            <img :src="`${publicPath}img/01avanzandoCrecimiento.jpg`" class="img-responsive" id="imgCrecimiento">
        </div>
    </div>
    <div class="row d-block d-lg-none">
        <div class="col-11 mx-3 mt-3 text-start">
            <h5>{{ $t('crecimiento.la-continua-evolución')}}</h5>
        </div>
    </div>
</div>
<!-- end HEAD -->

    <!-- Content -->
    <div class="container-xxl mb-5">
        <div class="franjaODS d-none d-lg-block">
            <ul class="mb-5">
                <li class="odsTxt">{{ $t('site.ODS-impacto-directo')}}</li>
                <li><img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive"></li>
                <li style="width: 90px"></li>
                <li class="odsTxt">{{ $t('site.ODS-impacto-indirecto')}}</li>
                <li><img :src="`${publicPath}img/ods1_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods2_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive"></li>
            </ul>
        </div>
        <div class="franjaODS d-block d-lg-none">
            <div class="row justify-content-between p-0 m-0">
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>
                </div>
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods1_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods2_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
    <div class="container-xxl pt-5">
        <div class="row position-relative p-0 m-0">
                <div class="col-12 col-lg-5 capaTrans text-start pt-0 pt-lg-5">
                    <h2 class="mt-0 mt-lg-5 mt-5">{{ $t('crecimiento.desarrollo-centros')}}</h2>
                    <h5 class="mt-5 txtGris pe-0 pe-lg-5">{{ $t('crecimiento.la-integración-red')}}</h5>
                </div>
                <div class="col-12 p-0 m-0">

                    <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img :src="`${publicPath}img/Crecimiento-Desarrollo-competencia-1.jpg`" class="img-responsive mb-4">
                            </div>
                            <div class="carousel-item">
                                <img :src="`${publicPath}img/Crecimiento-Desarrollo-competencia-2.jpg`" class="img-responsive mb-4">
                            </div>
                            <div class="carousel-item">
                                <img :src="`${publicPath}img/Crecimiento-Desarrollo-competencia-3.jpg`" class="img-responsive mb-4">
                            </div>
                            <div class="carousel-item">
                                <img :src="`${publicPath}img/Crecimiento-Desarrollo-competencia-4.jpg`" class="img-responsive mb-4">
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                            <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                            <span class="visually-hidden">{{ $t('previous') }}</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                            <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                            <span class="visually-hidden">{{ $t('next') }}</span>
                        </button>
                    </div>


                </div>
        </div>
    </div>
    <div class="container-xxl">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="boxGris p-5 pe-4 text-start fullHeight">
                        <h3 class="h3Crecimiento mb-4">{{ $t('crecimiento.griferia')}}<br><br></h3>
                        <p class="txtGris">{{ $t('crecimiento.desarrollo-soluciones-respondan')}}</p>
                    </div>
            </div>
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="boxGris p-5 pe-4 text-start">
                    <h3 class="h3Crecimiento mb-4">{{ $t('crecimiento.muebles-baño')}}</h3>
                    <p class="txtGris">{{ $t('crecimiento.implantacion-modelo')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-down" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="boxGris p-5 pe-4 text-start">
                    <h3 class="h3Crecimiento mb-4">{{ $t('crecimiento.sistemas-instalacion')}}</h3>
                    <p class="txtGris">{{ $t('crecimiento.diseño-mecanismo')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-down" data-aos-delay="400" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="boxGris p-5 pe-4 text-start">
                    <h3 class="h3Crecimiento mb-4">{{ $t('crecimiento.composites')}}<br><br></h3>
                    <p class="txtGris">{{ $t('crecimiento.proyecto-construccion')}}</p>
                </div>
            </div>
        </div>
        <div class="row g-3 mt-1">
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-down" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="boxGris p-5 pe-4 text-start">
                        <h3 class="h3Crecimiento mb-4">{{ $t('crecimiento.baneras-acero')}}</h3>
                        <p class="txtGris">{{ $t('crecimiento.centralizacion-procesos')}}</p>
                    </div>
            </div>
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-down" data-aos-delay="600" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="boxGris p-5 pe-4 text-start">
                    <h3 class="h3Crecimiento mb-4">{{ $t('crecimiento.mamparas-accesorios')}}</h3>
                    <p class="txtGris">{{ $t('crecimiento.desarrollo-soluciones')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="zoom" data-aos-delay="700" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="p-5 ps-0 ps-lg-5 pe-0 pe-lg-5 text-start">
                    <h4 class="mt-0 mt-lg-5 pt-0 pt-lg-5 txtBlau" v-html="$t('crecimiento.los-centros-competencia')"></h4>
                </div>
            </div>
        </div>
        <hr class="mt-0 mt-lg-5 mb-lg-5 borderGris">
    </div>

    <div class="container-xxl pt-3 pt-lg-5">
        <div class="row position-relative p-0 m-0">
            <div class="col-12 col-lg-5 capaTrans text-start pt-0 pt-lg-5">
                <h2 class="mt-0 mt-lg-5 pe-5">{{ $t('crecimiento.medidas-para-gestion')}}</h2>
                <h5 class="mt-5 txtGris pe-0 pe-lg-5">{{ $t('crecimiento.uno-principales')}}</h5>
            </div>
            <div class="col-12 p-0 m-0">
                <img :src="`${publicPath}img/01avanzandoCrecimientoB.jpg`" class="img-responsive">
            </div>
        </div>
    </div>
    <div class="container-xxl">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-down" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-0 pe-0 pe-lg-5 text-start">
                    <h4 class="mt-0 pt-0 pt-lg-5 txtBlau">{{ $t('crecimiento.la-gestion-integrada')}}</h4>
                </div>
            </div>
            <div class="col-12 col-lg-3 p-0 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="p-3 pe-3 pe-lg-5 pt-0 pt-lg-5 text-start fullHeight">
                    <h4 class="mb-4">{{ $t('crecimiento.creacion-comite')}}<br><br></h4>
                    <p class="txtGris pe-0 pe-lg-5">{{ $t('crecimiento.reuniones-regulares')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-3 p-0 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="p-3 pe-5 pt-0 pt-lg-5 text-start">
                    <h4 class="mb-4">{{ $t('crecimiento.integracion-plantas')}}</h4>
                    <p class="txtGris pe-0 pe-lg-5">{{ $t('crecimiento.la-planificacion-producción')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-3 p-0 aos-init aos-animate" data-aos="fade-down" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="p-3 pe-5 pt-0 pt-lg-5 text-start">
                    <h4 class="mb-4">{{ $t('crecimiento.racionalizacion-portafolio-producto')}}<br></h4>
                    <p class="txtGris pe-0 pe-lg-5">{{ $t('crecimiento.racionalización-portafolio-distintas')}}</p>
                </div>
            </div>
        </div>
        <hr class="my-5 borderGris">

    </div>

    <div class="container-xxl pt-0 pt-lg-5">
        <div class="row position-relative p-0 m-0">
            <div class="col-12 col-lg-5 capaTrans text-start pt-0 pt-lg-5">
                <h2 class="mt-0 mt-lg-5">{{ $t('crecimiento.inversion-tecnologia')}}</h2>
                <h5 class="mt-5 txtGris pe-0 pe-lg-5">{{ $t('crecimiento.fiel-politica')}}</h5>
            </div>
            <div class="col-12 p-0 m-0">
                <img :src="`${publicPath}img/01avanzandoCrecimientoC.jpg`" class="img-responsive">
            </div>
        </div>
    </div>
    <div class="container-xxl">
        <div class="row justify-content-end g-3 mt-2">
            <div class="col-12 col-lg-4 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="p-0 p-lg-3 pe-0 pe-lg-5 pt-5 text-start fullHeight">
                    <p class="txtGris">{{ $t('crecimiento.entre-principales-actuaciones')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-7 aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-4 pe-0 pe-lg-5 mt-0 mt-lg-5 text-start">
                    <h4 class="txtBlau" v-html="$t('crecimiento.cabe-destacar')"></h4>
                </div>
            </div>
        </div>
        <hr class="my-5 borderGris">

    </div>

    <div class="container-fluid">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="bg-dark p-5 text-start fullHeight">
                    <h4 class="h3Crecimiento mb-4 pe-0 pe-lg-5">{{ $t('crecimiento.refuerzo-EEUU')}}</h4>
                    <p class="txtGris pe-0 pe-lg-5">{{ $t('crecimiento.roca-group-anuncio')}}</p>
                    <div class="row justify-content-lg-end">
                        <div class="col-10 col-lg-5 pe-5">
                            <img :src="`${publicPath}img/01avanzandoCrecimientoMadeli.png`" class="img-responsive">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="bg-dark p-5 text-start fullHeight">
                    <h4 class="h3Crecimiento mb-4 pe-0 pe-lg-5">{{ $t('crecimiento.transformación-planta')}}</h4>
                    <p class="txtGris pe-0 pe-lg-5">{{ $t('crecimiento.en-2022-tambien')}}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- end Content -->
    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/avanzando-hacia-el-futuro" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase" v-html="$t('nav.avanzando')"></h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.excelencia-operacional") }}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->
</template>

<script>
  export default {
    name: "AvanzandoHaciaElFuturoCrecimientoView",
    data() {
            return {
                publicPath: process.env.BASE_URL,
                locale:this.$i18n.locale
            }
        }
  }

</script>
